export default __webpack_public_path__ + "static/media/waiter.366769b0.svg";